import React, { PureComponent } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import FormCore from "@/components/display/form/formCore";
import PropTypes from "prop-types";
import { Modal } from "antd";
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@CityDataFilterHoc
@connect((state) => state)
class EquipmentListModalDel2 extends PureComponent {
  constructor(props) {
    super(props);
    // 获取父组件传递的参数
    this.props = props;
    this.internationalization = this.props.intl.messages.equipmentListModalDel;
    this.state = {
      dataSource: [],
      query: {},
      ...this.setTableConfig(),
    };
    this.generateSchema();
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  fetchStationList = (params) => {
    let dataSource = [];
    if (params.keywords) {
      const name = params.keywords;
      if (this.props.selectedStations) {
        this.props.selectedStations.map((item) => {
          if (item.name === name) {
            dataSource.push(item);
          }
          return true;
        });
      }
    } else {
      dataSource = this.props.selectedStations;
    }
    this.setState({ dataSource: dataSource }, () => {
      this.setState({
        ...this.setTableConfig(),
      });
    });
  };

  // 表格列的定义
  generateSchema() {
    this.formConfig = {
      childItems: [
        {
          type: "input",
          inputType: "text",
          placeholder: this.internationalization.title3, // '电站名称',
          param: {
            name: "keywords",
            type: "string",
          },
          disabled: false, // 是否禁用：新增时则为false,编辑为true
          labelName: this.internationalization.title3, // '电站名称'
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              text: this.internationalization.btn1, // '查询',
              // icon: 'search',
              type: "primary",
              handler: (e, param) => {
                this.setState({
                  query: param,
                });
                this.fetchStationList(param);
              },
            },
          ],
        },
      ], // 设置表单元素
      layout: "inline", // 设置布局 0：横向布局 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        type: this.props.type,
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "ac_stationList_del2",
    };
  }

  setTableConfig() {
    return {
      tableConfig: {
        tableColumns: [
          {
            name: this.internationalization.title3, // '电站名称',
            key: "name",
          },
          {
            name: "操作",
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              {
                type: "confirm",
                actionName: this.internationalization.btn2, // '删除',
                handler: (record) => {
                  this.props.delete([record]);
                  this.fetchStationList(this.state.query); // 触发渲染，再次查询
                },
              },
            ],
          },
        ],
        tableParam: {},
        tableInfo: {},
        tableChange: () => {
          // grid翻页页，排序， 筛选过滤时触发
        },
        autoRefresh: true, // 设置为true 直接加载grid数据
        dataApi: this.state
          ? this.state.dataSource
          : this.props.selectedStations || [],
        tableKey: "ac_stationList_del2",
      },
    };
  }

  render() {
    return (
      <Modal
        title={this.internationalization.title3}
        footer={null}
        visible={this.props.visible}
        destroyOnClose
        onCancel={this.props.cancel}
        width="1000px"
      >
        <FormCore formConfig={this.formConfig} />
        <ScGridTable config={this.state.tableConfig} />
      </Modal>
    );
  }
}

export default injectIntl(EquipmentListModalDel2);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/equipmentListModalDel2.js